import { contactsStore } from "Stores/ContactsStore";
import { formatUsername } from "utils/formatUsername";

/**
 * Converts @id{number} to username. Used to normalize string data received from back-end before the display.
 * Example: "Hello, @id2" will be converted into "Hello, Admin".
 * NOTE: Make sure to fetch contactsStore before using this function.
 * @param comment - comment
 */
export function formatUserIdToName(comment: string) {
  const mentionIds = comment.match(/@id(\d*)/g); // get all id's
  let formattedComment = comment;
  if (mentionIds !== null) {
    mentionIds.forEach((mention) => {
      const mentionId = mention.replace("@id", ""); // extract userId
      const contactObject = contactsStore.projectUsers.find((i) => i.id === +mentionId);
      const name = contactObject ? formatUsername(contactObject) : `${mentionId} (not found)`;

      const newString = formattedComment.replace(
        // replace userId with corresponding number id
        `${mention}`,
        `<b>${name}</b>`
      );
      formattedComment = newString;
    });
  }
  return formattedComment;
}
